import { Pressable, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTranslation } from 'react-i18next';

import { AppText } from '@/components/ui/app-text';
import { colors, radius, spacing } from '@/theme/tokens';
import type { CategoryId } from '@/types/domain';

export const CATEGORY_ICONS: Record<CategoryId, keyof typeof Ionicons.glyphMap> = {
  FOOD: 'restaurant-outline',
  FUEL: 'speedometer-outline',
  BILLS: 'receipt-outline',
  INSTALLMENTS: 'card-outline',
  KIDS: 'happy-outline',
  HOME: 'home-outline',
  HEALTH: 'medkit-outline',
  FUN: 'sparkles-outline',
  OTHER: 'ellipsis-horizontal',
};

const CATEGORY_ORDER: CategoryId[] = ['FOOD', 'FUEL', 'BILLS', 'INSTALLMENTS', 'KIDS', 'HOME', 'HEALTH', 'FUN', 'OTHER'];

/** 3x3 category grid — smart default: last used category preselected */
export function CategoryGrid({ selected, onSelect }: { selected: CategoryId | null; onSelect: (c: CategoryId) => void }) {
  const { t } = useTranslation();
  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: spacing.sm }}>
      {CATEGORY_ORDER.map((cat) => {
        const active = cat === selected;
        return (
          <Pressable
            key={cat}
            accessibilityRole="button"
            onPress={() => onSelect(cat)}
            style={({ pressed }) => ({
              width: '31%',
              flexGrow: 1,
              alignItems: 'center',
              gap: spacing.base,
              backgroundColor: active ? colors.navy : colors.card,
              borderRadius: radius.button,
              paddingVertical: spacing.md,
              transform: [{ scale: pressed ? 0.98 : 1 }],
            })}
          >
            <Ionicons name={CATEGORY_ICONS[cat]} size={24} color={active ? '#FFFFFF' : colors.navy} />
            <AppText variant="labelMd" color={active ? '#FFFFFF' : colors.navy}>
              {t(`budget.categories.${cat}`)}
            </AppText>
          </Pressable>
        );
      })}
    </View>
  );
}
